import { get } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const analyseData = async (listId) => {
  const builder = new UrlBuilder(`/analysis/analyse-data/${listId}`);
  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getAnalysisData = async (listId) => {
  const builder = new UrlBuilder(`/analysis/get-analysis-data/${listId}`);
  try {
    const response = await get(builder.toString());

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
